import { createSelector } from "reselect";
import { populationSectionSelector } from "../population_section_selector";

export const dateSelectionSelector = createSelector(
  populationSectionSelector,
  population => {
    return population.dateSelection;
  }
);
